import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomPage from "../../../components/CustomPage";
import { useEffect, useState } from "react";
import { apiUrl } from "../../../config/settings";
import { useDispatch, useSelector } from "react-redux";
import http from "../../../http";
import { setDeleteMassage, setShowLoading } from "../../../store/sysSlice";
import Details from "./Details";
import { ArrowForwardIos, CopyAll, Delete, DeleteOutline, Edit } from "@mui/icons-material";
import CustomButton from "../../../components/CustomButton";
import { IconButton, Stack, Typography } from "@mui/material";
import { endpointNameItems, endpointNameList } from "../const";
import useDataManager from "../../../hooks/useDataManager";
import CustomDataGrid from "components/customDataGrid";
import { useNavigate, useParams } from "react-router-dom";
import CustomIconButton from "components/CustomIconButton";
import CustomDialog from "components/CustomDialog";
import { lineText } from "config/functions";
import moment from "moment";

const CheckList = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();
  const { removeItem, addItem } = useDataManager();
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const maxItems = useSelector((state) => state?.biz?.data?.plan?.maxItems);
  const clients = useSelector((state) => state?.clients?.list);
  const [list, setList] = useState([]);
  const [client, setClient] = useState(null);
  const [itemDetails, setItemDetails] = useState(null);
  const [checkListByQty, setCheckListByQty] = useState(null);
  const [itemDesc, setItemDesc] = useState(null);

  const columns = [
    {
      field: "name",
      headerName: bt("NAME"),
      width: 150,
    },
    {
      field: "desc",
      headerName: bt("DESC"),
      width: 250,
      renderCell: (values) => {
        return (
          values?.row?.desc
            ? <Stack height='100%' justifyContent='center'>
              <CustomButton
                variant="outlined"
                title={values?.row?.desc}
                onClick={(e) => {
                  e.stopPropagation();
                  setItemDesc(values?.row?.desc)
                }}
              />
            </Stack>
            : null
        )
      }
    },
    {
      field: "openQty",
      headerName: bt("CHECK_LIST_OPENED"),
      width: 170,
      align: "center",
    },
    {
      field: "closedQty",
      headerName: bt("CHECK_LIST_CLOSED"),
      width: 170,
      align: "center",
    },
    {
      field: "edit",
      headerName: bt("EDIT"),
      width: 100,
      hideInExport: true,
      filterable: false,
      renderCell: (values) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setItemDetails(values?.row);
            }}
          >
            <Edit />
          </IconButton>
        );
      },
    },
    {
      field: "copy",
      headerName: bt("COPY"),
      width: 100,
      hideInExport: true,
      filterable: false,
      renderCell: (values) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              copylist(values?.row);
            }}
          >
            <CopyAll />
          </IconButton>
        );
      },
    },
    {
      field: "delete",
      headerName: bt("DELETE"),
      width: 100,
      hideInExport: true,
      filterable: false,
      renderCell: (row) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              deleteItemDetail(row.id);
            }}
          >
            <DeleteOutline sx={{ color: "error.text" }} />
          </IconButton>
        );
      },
    },
  ]

  useEffect(() => {
    getDataByQty();
  }, []);

  useEffect(() => {
    if (clientId && clients?.length > 1 && list?.length === 0) {
      getData();
    }
  }, [clientId, clients]);

  const getDataByQty = () => {
    http.get(`/${endpointNameItems}/byQty`).then((res) => {
      if (res?.data?.id === 1) {
        setCheckListByQty(res?.data?.data);
      }
    })
  }

  const getData = () => {
    dispatch(setShowLoading(true));
    http.get(`${apiUrl}/${endpointNameList}/byClient/${clientId}`).then((res) => {
      setList(res?.data?.data);
      setClient(clients?.find((c) => c?._id === clientId));
      dispatch(setShowLoading(false));
    });
  };

  const itemDetailsHandle = (item) => {
    setItemDetails(item);
  };

  const deleteItemDetail = (id) => {
    dispatch(
      setDeleteMassage({
        massage: "DELETE_ITEM",
        onClick: () => {
          dispatch(setShowLoading(true));
          http
            .delete(`${apiUrl}/${endpointNameList}/${id}`)
            .then((res) => {
              dispatch(setShowLoading(false));
              const newList = removeItem(id, list);
              setList(newList);
            })
            .catch((error) => {
              dispatch(setShowLoading(false));
            });
        },
      })
    );
  };

  const backToClients = () => {
    navigate("/Check-List");
  }

  const onSelected = (item) => {
    navigate(`/Check-List/${clientId}/${item?.id}`);

  }

  const copylist = (item) => {
    dispatch(setShowLoading(true));
    http.post(`${apiUrl}/${endpointNameList}/copy/${item?.id}`)
      .then((res) => {
        dispatch(setShowLoading(false));
        if (res?.data?.id === 1) {
          getDataByQty();
          const data = {
            ...item,
            id: res?.data?.itemId,
            name: `${item?.name} Copy`,
            isClosed: false,
            closedDate: null,
            created: moment()
          };

          const newList = addItem(data, list);
          setList(newList);
          setItemDetails(data);
        }
      })
      .catch((error) => {
        dispatch(setShowLoading(false));
        console.error("error", error)
      });
  }

  return (
    <CustomPage
      title={`${bt('RECORDS')} - ${client ? client?.company || client?.contactName : ""}`}
      icon={
        <CustomIconButton
          size={30}
          iconColor='primary'
          hideBgcolor icon={<ArrowForwardIos fontSize="small" />}
          onClick={backToClients}
        />
      }
      header={
        <Stack direction="row" justifyContent="end">
          <CustomButton title="NEW"
            disabled={maxItems > 0 && list?.length >= maxItems}
            onClick={() => itemDetailsHandle({ id: "new" })}
          />
        </Stack>
      }
    >
      {checkListByQty
        ? <CustomDataGrid
          setItem={onSelected}
          getRowClassName={(params) => { return params?.row?.openQty === 0 && params?.row?.closedQty > 0 ? "cold" : "" }}
          columns={columns}
          list={list?.map((item) => {
            const checkList = checkListByQty?.find(c => c?.checkListId === item?.id);
            return {
              ...item,
              id: item?.id,
              closedQty: checkList?.closedQty || 0,
              openQty: checkList?.openQty || 0,
            }
          }
          )}
        />
        : null
      }

      {itemDetails
        ? <Details
          item={itemDetails}
          setList={setList}
          list={list}
          setItem={setItemDetails}
          getData={getData}
          clientId={clientId}
        />
        : null
      }

      {itemDesc
        ? <CustomDialog
          open={itemDesc ? true : false}
          title={bt("DESC")}
          onClose={() => setItemDesc(null)}
          closeBtn="CLOSE"
        >
          <Stack minWidth={{ xs: "auto", sm: 250 }}>
            <Typography textAlign='center' padding={1}>
              {lineText(itemDesc)}
            </Typography>
          </Stack>
        </CustomDialog>
        : null
      }
    </CustomPage>
  );
};
export default CheckList;
